<nz-header #header>
  <nz-page-header>
    <nz-page-header-title *ngIf="!onlyName">
      <nz-row nzAlign="middle" style="flex-wrap: nowrap">
        <nz-col *ngIf="isMobile && collapsed">
          <button (click)="onColapse.emit()" nz-button nzType="text" nzShape="circle">
            <mat-icon fontSet="material-icons-outlined"> menu </mat-icon>
          </button>
        </nz-col>
        <nz-col>
          <h1>{{ title }}</h1>
        </nz-col>
      </nz-row>
    </nz-page-header-title>

    <nz-page-header-title *ngIf="onlyName" class="small-height">
      <nz-col>
        <h1>{{ user?.name }}</h1>
      </nz-col>
    </nz-page-header-title>

    <nz-page-header-extra *ngIf="onlyName" class="small-height">
      <nz-space class="small-height" nzAlign="center" [nzSize]="4">
        <button *nzSpaceItem nz-button nzType="text" nzShape="circle" (click)="logout()">
          <mat-icon fontSet="material-icons-outlined">logout</mat-icon>
        </button>
      </nz-space>
    </nz-page-header-extra>

    <nz-page-header-subtitle *ngIf="!onlyName">{{ subtitle }}</nz-page-header-subtitle>

    <nz-page-header-extra *ngIf="!onlyName">
      <nz-space nzAlign="center" [nzSize]="4">
        <form [formGroup]="form">
          <nz-input-group [nzSuffix]="suffixIconSearch" *ngIf="headerService.searchAction">
            <input
              class="search"
              type="text"
              formControlName="searchString"
              nz-input
              [placeholder]="headerService.searchPlaceholder"
            />
          </nz-input-group>
        </form>

        <button *nzSpaceItem nz-button nzType="text" nzShape="circle" (click)="openNotificationDrawer()">
          <nz-badge [nzCount]="noticeCount">
            <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
          </nz-badge>
        </button>

        <ng-template #suffixIconSearch>
          <span nz-icon nzType="search"></span>
        </ng-template>
      </nz-space>
    </nz-page-header-extra>
  </nz-page-header>

  <nz-breadcrumb *ngIf="!onlyName">
    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs">
      <nz-row [routerLink]="breadcrumb.url">
        <nz-col>
          <mat-icon *ngIf="breadcrumb.icon" fontSet="material-icons-outlined">
            {{ breadcrumb.icon }}
          </mat-icon>
        </nz-col>
        <nz-col>
          <span>{{ breadcrumb.label }}</span>
        </nz-col>
      </nz-row>
    </nz-breadcrumb-item>
  </nz-breadcrumb>
</nz-header>

<nz-divider></nz-divider>

<nz-drawer
  #drawer
  [nzMaskClosable]="true"
  [nzVisible]="false"
  [nzClosable]="true"
  [nzCloseOnNavigation]="false"
  nzTitle="Notificações"
  (nzOnClose)="onNotificationDrawerClose()"
  [nzWidth]="
    header.elementRef.nativeElement.offsetWidth > 400
      ? 400
      : header.elementRef.nativeElement.offsetWidth
  "
>
  <az-blc-notification
    *nzDrawerContent
    (closeDrawer)="onNotificationDrawerClose()"
  ></az-blc-notification>
</nz-drawer>
